import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { fetchPages } from '../../api'

function Pages() {

    const [pages, setPages] = useState([])

    const [page, setPage] = useState(1)
    const [perPage, setPerPage] = useState(100)

    const [isLoading, setIsLoading] = useState(true)

    useEffect(() => {

        async function getPages() {
            setIsLoading(true)
            const data = await fetchPages(page, perPage);
            if (data?.length) {
                setPages(data);
            }
            setIsLoading(false);
        }
        getPages();

    }, [page, perPage])

    return (
        <div className="my-4">
            {pages?.map((page, index) => {
                return (
                    <div key={index} className="card card-body my-3">
                        <h2><Link to={`/pages/${page?.id}`}>{page?.title?.rendered}</Link></h2>
                    </div>
                )
            })}
        </div>
    )
}
export default Pages